/**
 * @fileoverview PATCH handler for the "/:app_group_id/knowledge_source/definition/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { knowledgeSourceDefinitionIdCacheKeys } from "./constants";
import type {
  KnowledgeSourceDefinitionIdResult,
  UpdateKnowledgeSourceDefinitionIdErrors,
  UpdateKnowledgeSourceDefinitionIdProps,
} from "./types";

export const patchKnowledgeSourceDefinitionId = reactQueryMutationAdapter(
  knowledgeSourceDefinitionIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<UpdateKnowledgeSourceDefinitionIdErrors>()(
    (props: UpdateKnowledgeSourceDefinitionIdProps): Promise<KnowledgeSourceDefinitionIdResult> => {
      return fetch(
        `/${props.appGroupId}/knowledge_source/definition/${props.definitionId}`,
        "PATCH",
        { description: props.description },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
